// Document-specific validation - Uses generic validation utility
import { createValidation } from '../../../utils/validation';

/**
 * Document-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing document module code
 */
export const createDocumentValidation = (fields) => {
  const validation = createValidation(fields);
  
  // Return the same interface but with document-specific method names
  return {
    schema: validation.schema,
    validateDocumentData: validation.validateData,
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createDocumentValidation;
